import React from 'react';

const DescriptionCard = ({ metadata }) => {
  const description = metadata?.description || 'No description available';
  
  return (
    <div className="bg-white dark:bg-neutral-950 rounded-lg border border-gray-200 dark:border-neutral-800">
      <div className="p-3 border-b border-gray-200 dark:border-neutral-800">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-neutral-100">Description</h3>
      </div>
      <div className="p-2 max-h-48 overflow-y-auto">
        <p className="text-xs text-gray-700 dark:text-neutral-300 whitespace-pre-wrap leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};

export default DescriptionCard;

